export const DEFAULT_PLACE_IMAGE = '/whereyogi.jpg'; 